import PropTypes from 'prop-types';
import { Modal } from 'antd';

const ResultTag = ({ status }) => (
  <span className={status === 'pass' ? 'diagnostics-result-pass' : 'diagnostics-result-fail'}>
    {status === 'pass' ? 'PASS' : 'FAIL'}
  </span>
);

ResultTag.propTypes = { status: PropTypes.string };

const DiagnosticDetails = ({ open, onClose, categories }) => (
  <Modal
    title="Diagnostic Details"
    open={open}
    onCancel={onClose}
    footer={null}
    width={560}
    centered
    className="diagnostics-details-modal"
  >
    {categories.map((category) => (
      <div key={category.key} className={`diagnostics-group diagnostics-group-${category.status}`}>
        <div className="diagnostics-group-header">
          <span className="diagnostics-group-title">{category.title}</span>
          <ResultTag status={category.status} />
        </div>
        <div className="diagnostics-group-columns">
          <span>TEST</span>
          <span>PORT</span>
          <span>RESULT</span>
        </div>
        {category.tests.map((test) => (
          <div key={test.label} className={`diagnostics-test-row diagnostics-test-${test.status}`}>
            <div className="diagnostics-test-main">
              <span className="diagnostics-test-label">{test.label}</span>
              <span className="diagnostics-test-port">{test.port}</span>
              <ResultTag status={test.status} />
            </div>
            {test.status === 'fail' && test.failMessage && (
              <p className="diagnostics-test-message">{test.failMessage}</p>
            )}
          </div>
        ))}
      </div>
    ))}
  </Modal>
);

DiagnosticDetails.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  categories: PropTypes.array,
};

export default DiagnosticDetails;
